/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brave_Red_Hawk_SoarInputs */

const en_brave_red_hawk_soar = /** @type {(inputs: Brave_Red_Hawk_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

const de_brave_red_hawk_soar = /** @type {(inputs: Brave_Red_Hawk_SoarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen`)
};

/**
* | output |
* | --- |
* | "Create" |
*
* @param {Brave_Red_Hawk_SoarInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const brave_red_hawk_soar = /** @type {((inputs?: Brave_Red_Hawk_SoarInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brave_Red_Hawk_SoarInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_brave_red_hawk_soar(inputs)
	return de_brave_red_hawk_soar(inputs)
});